export const getDteInvalidationLogActions = ({
  row,
  handlers,
}: {
  row: any;
  handlers: {
    onViewDetail: (id: number) => void;
  };
}) => [
  {
    key: 'view',
    label: 'Ver detalle',
    onClick: () => handlers.onViewDetail(row.id),
  },
];
